// Relative imports
import { axiosInstance } from "./common";

// Opt-outs of the shared interceptor (api/common.jsx): a 403 on ai/* must not log the user out, and
// a 500 must not repeat a whole model call.
const AI_REQUEST_CONFIG = { skipAuthRedirect: true, skipRetryOn5xx: true };

// The backend gives the model about 50 s and nginx cuts at 60 s: wait a bit longer than that, so
// the server's own error (503, 502) reaches the user instead of a client timeout.
export const AI_CHAT_TIMEOUT_MS = 65000;

/**
 * Whether the AI assistant is on for this tenant.
 * 200 {ok, data: {enabled, model}}; 404 when the backend has no API key (= disabled).
 * Not meant for client users (CU): the view answers 403 (no logout thanks to skipAuthRedirect).
 */
export const getAiStatus = async () => {
  const endpoint = "ai/status/";
  return axiosInstance
    .get(endpoint, AI_REQUEST_CONFIG)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

/**
 * One turn of the AI chat (read only on the CRM data, not streamed).
 * @param {{ messages: {role: "user"|"assistant", content: string}[],
 *   context?: { path?: string, company_id?: string, company_name?: string } }} data
 * @param {{ signal?: AbortSignal }} [options]
 * @returns {Promise<{ ok: boolean, data: { reply: string, tools_used: string[],
 *   stop_reason: string, usage: object } }>}
 */
export const sendAiChat = async (data, { signal } = {}) => {
  const endpoint = "ai/chat/";
  return axiosInstance
    .post(endpoint, data, { ...AI_REQUEST_CONFIG, signal, timeout: AI_CHAT_TIMEOUT_MS })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
